import { SvgIcon, SvgIconProps } from '@mui/material'

const Close = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M3.47 3.47a.75.75 0 0 1 1.06 0l16 16a.75.75 0 1 1-1.06 1.06l-16-16a.75.75 0 0 1 0-1.06Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M20.53 3.47a.75.75 0 0 1 0 1.06l-16 16a.75.75 0 0 1-1.06-1.06l16-16a.75.75 0 0 1 1.06 0Z" fill="currentColor" />
    </SvgIcon>
  )
}

export default Close
